const refreshToken = async () => {
  const request = new Request(
    `${process.env.REACT_APP_API_URL}/authentication/refresh`,
    {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({ 'Content-Type': 'application/json' }),
    },
  );
  const response = await fetch(request);
  if (response.status < 200 || response.status >= 300) {
    throw new Error('Unauthorized');
  }
  const auth = await response.json();

  localStorage.setItem('auth', JSON.stringify(auth));
};

const  normalizeHeaders = (headers: any) => {
  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries());
  } else if (typeof headers === 'object' && headers !== null) {
    return { ...headers }; // Already a plain object
  } else {
    return {}; // Return empty object if headers is a string, null, or undefined
  }
}

export const authenticatedFetch = async (
  input: RequestInfo | URL,
  options: RequestInit | undefined = {},
  iteration: number = 0,
): Promise<Response> => {
  const headers = normalizeHeaders(options.headers);
  const authItem = localStorage.getItem('auth');
  if (authItem) {
    try {
      const auth = JSON.parse(authItem);
      if (auth && auth.token) {
        headers.Authorization = `Bearer ${auth.token}`;
      }
    } catch (e) {}
  }
  options.credentials = 'include';

  if(!headers.Accept){
    headers.Accept = 'application/json'
  }
  if(!headers['Content-Type']){
    headers['Content-Type'] = 'application/json; charset=UTF-8'
  }

  const response = await fetch(input, {...options, headers});
  if (response.status === 401 || response.status === 400 || response.status === 404) {
    const { message } = await response.json();
    if (iteration === 0 && message === 'Token expired') {
      try {
        await refreshToken();
      } catch (e) {
        localStorage.removeItem('auth');
        throw new Error('Unauthorized');
      }
      return await authenticatedFetch(input, options, iteration + 1);
    }
    localStorage.removeItem('auth');
    throw new Error('Unauthorized');
  }
  return response;
};
